import { Controller } from '@hotwired/stimulus';
import { showToast } from '../lib/toast';

// "Configuration du modèle" modal (custom templates, opened from the show kebab
// via the window "config:open" event). Submits over fetch to metadatas#update:
// success reloads the show (reflects title/orientation + flash), 422 shows
// inline field errors.
export default class extends Controller {
  static targets = ['form', 'submit', 'spinner'];

  connect() {
    this.onKeydown = this.onKeydown.bind(this);
  }

  disconnect() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  open() {
    this.element.hidden = false;
    document.addEventListener('keydown', this.onKeydown);
    const first = this.formTarget.querySelector('input, textarea');
    if (first) first.focus();
  }

  close() {
    this.element.hidden = true;
    document.removeEventListener('keydown', this.onKeydown);
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close();
  }

  backdropClose(event) {
    if (event.target === this.element) this.close();
  }

  clearField(event) {
    event.target.classList.remove('is-invalid');
    const error = this.errorFor(event.target.dataset.configField);
    if (error) error.hidden = true;
  }

  submit(event) {
    event.preventDefault();
    this.setSubmitting(true);

    fetch(this.formTarget.action, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-CSRF-Token': this.csrfToken() },
      body: new FormData(this.formTarget),
    })
      .then((response) => this.handleResponse(response))
      .catch(() => {
        this.setSubmitting(false);
        showToast('error', this.message());
      });
  }

  async handleResponse(response) {
    if (response.ok) {
      window.location.reload();
      return;
    }

    this.setSubmitting(false);
    if (response.status === 422) {
      const data = await response.json();
      this.showErrors(data.errors || {});
    } else {
      showToast('error', this.message());
    }
  }

  showErrors(errors) {
    this.clearAllErrors();
    Object.entries(errors).forEach(([field, messages]) => {
      const input = this.element.querySelector(`[data-config-field="${field}"]`);
      const error = this.errorFor(field);
      if (input) input.classList.add('is-invalid');
      if (error) {
        error.textContent = messages.join(', ');
        error.hidden = false;
      }
    });
  }

  clearAllErrors() {
    this.element
      .querySelectorAll('[data-config-field]')
      .forEach((input) => input.classList.remove('is-invalid'));
    this.element
      .querySelectorAll('[data-config-error]')
      .forEach((error) => { error.hidden = true; });
  }

  errorFor(field) {
    return this.element.querySelector(`[data-config-error="${field}"]`);
  }

  setSubmitting(submitting) {
    this.submitTarget.disabled = submitting;
    this.spinnerTarget.classList.toggle('hidden', !submitting);
  }

  message() {
    return this.element.dataset.errorMessage || '';
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }
}
